import {Component, ViewEncapsulation} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {LoaderService, NavigateService} from '@satoris/ngx-satoris';
import {ScanShareData} from 'src/app/shared/models/claim';
import {ApiService} from 'src/app/shared/services/api.service';
import {ShareHandlerService} from 'src/app/shared/services/share-handler.service';
import {filter, take} from 'rxjs';

@Component({
  selector: 'app-scan-share-result',
  styleUrls: ['./scan-share-result.component.scss'],
  templateUrl: './scan-share-result.component.html',
  encapsulation: ViewEncapsulation.None
})
export class ScanShareResultComponent {
  data: ScanShareData;
  processing = true;

  constructor(public nav: NavigateService,
              public api: ApiService,
              private router: Router,
              private loader: LoaderService,
              private shareHandler: ShareHandlerService) {
    this.data = <any> this.router.getCurrentNavigation().extras.state;
    if(!this.data) {
      this.error('api.postClaim.invalidRequest');
      return;
    }
    const callback = this.api.userInfo.server.callbacks[this.data.service];
    if(!callback) {
      this.error('api.postClaim.invalidRequest');
      return;
    }
    if(this.data.claims?.length !== [...new Set(callback.types)].length) {
      this.error(this.shareHandler.missingClaimsMessage(callback.types));
      return;
    }
    setTimeout(() => {
      this.shareHandler.performShare(this.data, this.data.claims).then(() => {
        this.processing = false;
        this.showResultAndNavigate('valid', 'api.postClaim.success');
      }).catch((err) => {
        this.processing = false;
        this.error(this.shareHandler.errorMessage(err));
      });
    }, 500);
  }

  error(message = 'api.postClaim.error') {
    this.showResultAndNavigate('error', message);
  }

  private showResultAndNavigate(type: 'error' | 'valid' | 'info' | 'warn' | 'question', message: string) {
    this.router.events.pipe(filter(e => e instanceof NavigationEnd), take(1)).subscribe(() => {
      setTimeout(() => {
        this.loader.loading(true, this.shareHandler.loaderOptions(type, message));
      }, 100);
    });
    this.nav.to('user');
  }
}
